import Collapse from '@material-ui/core/Collapse';
import { useRef, useState } from "react";
import Button from "../../components/UI/Button/Button";
import Modal from "../../components/UI/Modal/Modal";
import Table from "../../components/UI/Table/Table";
import FetchData from "../../shared/fetchData";
import "./Events.css";
import Spinner from '../../components/UI/Spinner/Spinner';

const Events = (props) => {

    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showForm, setShowForm] = useState(false);
    const [rerender, setRerender] = useState(false);
    const [modalContent, setModalContent] = useState('');
    const [pageSize, setPageSize] = useState(10)
    const [pageIndex, setPageIndex] = useState(0)
    const [pageCount, setPageCount] = useState(0)
    const [tableData, setTableData] = useState([])
    const child = useRef();

    const changeEventStateSubmit = (id) => {
        var info = {
            "event": {
                "id": id,
            },
            "version": "mtpx001"
        }
        var raw = JSON.stringify(info)
        var url = 'management/api/v1/events/eventChangeState'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == "0") {
                    child.current.closeModal();
                    getData({ pageIndex: pageIndex, pageSize: pageSize });
                }
            })
            .catch(error => console.log(''))
    }
    const changeEventState = (id) => {
        setModalContent(<>
            <div className="row justify-content-center">
                آیا از تغییر وضعیت مطمئن هستید؟
            </div>
            <div className="row justify-content-center mt-4">
                <div className="col-6 text-center">
                    <Button btnType="Success" clicked={() => changeEventStateSubmit(id)}>بله</Button>
                </div>
                <div className="col-6 text-center">
                    <Button btnType="General" clicked={() => {
                        child.current.closeModal();
                    }}>خیر</Button>
                </div>
            </div>
        </>)
        child.current.openModal();
    }
    const afterCloseModal = (event) => {
    }
    const getData = (pagination, isRefresh) => {
        setPageIndex(pagination.pageIndex)
        setPageSize(pagination.pageSize)
        setLoading(true);
        var raw = !!isRefresh && isRefresh ? JSON.stringify({
            event: {},
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        }) : JSON.stringify({
            "event": {
            },
            "pl": pagination.pageSize,
            "pn": pagination.pageIndex + 1,
            "version": "mtpx001"
        })

        var url = 'management/api/v1/events/getEvents'
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                if (result.status == 0) {
                    let newList = []
                    for (let i = 0; i < (pagination.pageIndex * pagination.pageSize); i++) {
                        newList.push([]);
                    }
                    newList = newList.concat(result.events)
                    pushData(newList)
                    setEvents(newList)
                    setPageCount(result.count)
                    setLoading(false);
                } else {
                    setLoading(false)
                }
            })
            .catch(error => setLoading(false))
    }

    const pushData = (data) => {
        const rows = [];
        const headers = [
            {
                accessorKey: 'typeDescription',
                header: 'نوع رویداد',
                align: 'center',
            },
            {
                accessorKey: 'isActive',
                header: 'وضعیت',
                align: 'center',
            },
        ];
        const buttons = [];
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        data.map(d => {
            rows.push({
                id: d.id,
                typeDescription: d.typeDescription,
                isActive: d.isActive != null && d.isActive != "" && d.isActive == "1" ? "فعال است" : "فعال نیست",
            });
        })
        buttons.push({ id: 1, text: 'تغییر وضعیت', clicked: changeEventState });
        setTableData({ rows: rows, headers: headers, buttons: buttons });
        setRerender(!rerender);
    }

    const searchFn = (event) => {
        getData({ pageIndex: pageIndex, pageSize: pageSize })
    }

    return (
        <>
            {loading ? <Spinner /> : ''}
            <Collapse in={!showForm} className='mt-5' >
                {/* <Search form={form} /> */}
                {/* <div className="row justify-content-center mt-3">{add}</div> */}
                {rerender ?
                    // <Spinner />
                    <Table hasDetails={false} pageSize={pageSize} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={170} loading={loading} />
                    :
                    <Table hasDetails={false} pageSize={pageSize} pageIndex={pageIndex} getData={getData} list={tableData} rowCount={pageCount} columnSize={170} loading={loading} />
                }
                <Modal
                    content={modalContent}
                    ref={child}
                    closePermission={true}
                    closeModal={(event) => afterCloseModal(event)}
                />
            </Collapse>
        </>
    )
}

export default Events;